import BlTooltipMv from './BlTooltipMv.vue'

BlTooltipMv.install = function(Vue) {
  Vue.component(BlTooltipMv.name, BlTooltipMv)
}

export default BlTooltipMv
